import { PAGE_TYPE_CART } from 'shared/consts'
import { TRUSTED_SHOPS_WIDGET_CLICK } from 'shared/experiments/browser/trustedShopsWidgetInCart/events'
import { TRUSTED_SHOPS_WIDGET_IN_CART } from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

export default () => {
  const { isEnabled } = getExperimentOnClient(TRUSTED_SHOPS_WIDGET_IN_CART)
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { pageType } = publicRuntimeConfig?.pageProperties || {}

  if (!isEnabled || pageType !== PAGE_TYPE_CART) {
    return
  }

  void activateExperiment(TRUSTED_SHOPS_WIDGET_IN_CART)

  const trustedShopsWidget = <HTMLElement>(
    document.querySelector('#trusted-shops-widget')
  )

  trustedShopsWidget.addEventListener('click', () => {
    trackOptimizelyEvent(TRUSTED_SHOPS_WIDGET_CLICK)
  })
}
